import type { Nil, Unit, UserPreferredUnit } from '@core';

import { Stack } from '../../Layout';
import { ParameterCard } from '../ParameterCard';
import { ParameterStats } from '../ParameterStats';
import type { CorridorBounds } from '../types';
import { useParameters } from '../useParameters';

export type FloorParameterCardProps = {
    title: string;
    unit: Unit;
    userPreferredUnit: UserPreferredUnit;
    value: number | Nil;
    comparisonValue?: number | Nil;
    mean?: number | Nil;
    stdDev?: number | Nil;
    corridorParameterMargins?: CorridorBounds | Nil;
    goalCorridor?: CorridorBounds | Nil;
};

export const FloorParameterCard = ({
    title,
    unit,
    userPreferredUnit,
    value,
    comparisonValue,
    mean,
    stdDev,
    corridorParameterMargins,
    goalCorridor,
}: FloorParameterCardProps) => {
    const converted = useParameters({
        unit,
        value,
        comparisonValue,
        corridorParameterMargins,
        goalCorridorParameterMargins: goalCorridor,
        userPreferredUnit,
        mean,
        stdDev,
    });
    const indicatorColor = goalCorridor ? converted.goalIndicatorColor : converted.corridorIndicatorColor;

    return (
        <Stack gap={0}>
            <ParameterCard.Root
                corridors={
                    <ParameterCard.SingleCorridor
                        corridorParameterMargins={converted.corridorParameterMargins}
                        goalCorridor={converted.goalCorridor}
                        unit={converted.unit}
                        value={converted.value}
                        indicatorColor={indicatorColor}
                    />
                }
            >
                <ParameterCard.Title>{title}</ParameterCard.Title>
                <ParameterCard.Values>
                    <ParameterCard.Value
                        displayUnit={converted.unit}
                        symbol={converted.symbol}
                        value={converted.value}
                        indicatorColor={indicatorColor}
                    />
                    <ParameterCard.Comparison
                        displayUnit={converted.unit}
                        symbol={converted.symbol}
                        value={converted.comparison}
                    />
                </ParameterCard.Values>
            </ParameterCard.Root>
            <ParameterStats mean={converted.mean} stdDev={converted.stdDev} />
        </Stack>
    );
};
